module.exports = __webpack_public_path__ + "static/media/EventsApp-Background.aea5db6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/EventsApp-Background.png
// module id = 75
// module chunks = 0